import { useState, useMemo } from 'react';
import './editCaretakersBox.css';
import { Button } from './Button';
import { CaretakersService } from '../services/supabase/caretakersService';
import { UserService } from '../services/user/userService';
import { supabase } from '../utils/supabase_config';

export const EditCaretakersBox = (props) => {

  const [showingDeactivated, setShowingDeactivated] = useState(false);
  const [inputs, setInputs] = useState({});

  const sortedCaretakers = useMemo(() =>
    [...props.caretakerList].sort((a, b) => a.name.localeCompare(b.name)),
    [props.caretakerList]
  );

  const getInput = (id, field, fallback) => {
    if (inputs[id] && inputs[id][field] !== undefined) return inputs[id][field];
    return fallback;
  };

  const setField = (id, field, value) =>
    setInputs(prev => ({ ...prev, [id]: { ...prev[id], [field]: value } }));

  const handleUpdate = async (caretaker) => {
    const email = getInput(caretaker.docID, 'email', caretaker.email);
    const color = getInput(caretaker.docID, 'color', caretaker.color);

    try {
      await CaretakersService.updateCaretaker(caretaker.docID, { email, color });
      await CaretakersService.updateShiftsForCaretaker(caretaker.name, {
        caretaker_email: email,
        color,
      });

      const { data: userRows } = await supabase
        .from('users')
        .select('id')
        .eq('name', caretaker.name);
      if (userRows && userRows.length > 0) {
        await UserService.updateUser(userRows[0].id, { email });
      }

      props.InitialLoadCaretakers();
      props.InitialLoadShifts();
      alert('Caretaker information updated successfully');
    } catch (error) {
      console.error('Error updating caretaker:', error);
      alert('Error updating caretaker information');
    }
  };

  const handleDelete = (caretaker) => {
    const userToDelete = props.userList.find(u => u.name === caretaker.name);
    props.setUserToDeleteID(userToDelete?.docID);
    props.setCaretakerToDeleteID(caretaker.docID);
    props.setCaretakerToDeleteName(caretaker.name);
    props.setDisplayDeleteCaretakerDialog(true);
  };

  const handleDeactivDelete = (deactiv) => {
    props.setCaretakerToDeleteID(deactiv.docID);
    props.setCaretakerToDeleteName(deactiv.name);
    props.setDisplayDeleteCaretakerDialog(true);
  };

  return (
    <div className="editCaretakersDiv" id="editCaretakersTarget">
      <h2>Edit Caretakers</h2>

      <Button
        onClick={() => setShowingDeactivated(v => !v)}
        type="button"
        buttonStyle="btn--success--solid"
        buttonSize="btn--medium"
      >
        {showingDeactivated ? 'Hide Deactivated Caretakers' : 'Show Deactivated Caretakers'}
      </Button>

      {showingDeactivated && (
        <table id="deactivatedCaretakersTable">
          <thead>
            <tr>
              <td>Name</td>
              <td>Email</td>
              <td>Pay</td>
              <td>Set to &apos;Deactivated&apos; on:</td>
            </tr>
          </thead>
          <tbody>
            {props.deactivatedCaretakersList.map(deactiv => {
              const d = new Date(deactiv.deactivationTime);
              const dateStr = `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`;
              return (
                <tr key={deactiv.docID} className="deactivCaretakerTR">
                  <td className="deactivTD">{deactiv.name}</td>
                  <td className="deactivTD">{deactiv.email}</td>
                  <td className="deactivTD">{deactiv.pay[0]}</td>
                  <td className="deactivTimeTD">{dateStr}</td>
                  <td>
                    <button
                      type="button"
                      className="updateCaretakerButton"
                      onClick={() => props.restoreCaretaker(deactiv)}
                    >
                      Reactivate
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="deleteClientButton"
                      onClick={() => handleDeactivDelete(deactiv)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      <div className="formSep"></div>

      <table id="caretakerEditBoxTable">
        <thead>
          <tr>
            <td>Name</td>
            <td>Email</td>
            <td>Pay</td>
            <td>Color</td>
          </tr>
        </thead>
        <tbody>
          {sortedCaretakers.map(ct => (
            <tr key={ct.docID} id={`caretakerRow${ct.name}`}>
              <td className="caretakerNameData">{ct.name}</td>
              <td>
                <input
                  className="caretakerEmailInput"
                  value={getInput(ct.docID, 'email', ct.email)}
                  onChange={e => setField(ct.docID, 'email', e.target.value)}
                />
              </td>
              <td>{ct.pay[0]}</td>
              <td>
                <input
                  type="color"
                  className="caretakerColorInput"
                  value={getInput(ct.docID, 'color', ct.color)}
                  onChange={e => setField(ct.docID, 'color', e.target.value)}
                />
              </td>
              <td id="updateCaretakerButtonTD">
                <button
                  type="button"
                  className="updateCaretakerButton"
                  onClick={() => handleUpdate(ct)}
                >
                  Update
                </button>
              </td>
              <td id="deleteCaretakerButtonTD">
                <button
                  type="button"
                  id="deleteCaretakerButton"
                  onClick={() => handleDelete(ct)}
                >
                  Delete / Deactivate
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
